import React from "react";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import { LABELS } from "../../../../constants/labels/jetlift/jetlift.labels";
import TableComponent from "../../../common/TableComponent";
import WidgetLoader from "../../../common/widgetloader";

const GasCalculations: React.FC = () => {
    const { gasIntakeData, loading } = useAppSelector((state) => state?.jetlift?.gasCalculations);
    const { fluidInput } = useAppSelector((state) => state?.jetlift?.fluid);

    const columns = [
        {
            title: "",
            dataIndex: "label",
            key: "label",
            sortable: false,
            width: "50%",
        },
        {
            title: "Intake",
            dataIndex: "intake",
            key: "intake",
            sortable: false,
            width: "50%",
        },
    ];

    const data = [
        {
            label: `${LABELS?.rs}`,
            intake: `${gasIntakeData?.rs ?? ""}`
        },
        {
            label: `${LABELS?.bg}`,
            intake: `${gasIntakeData?.bg ?? ""}`
        },
        {
            label: `${LABELS?.bo}`,
            intake: `${gasIntakeData?.bo ?? ""}`
        },
        {
            label: `${LABELS?.volumeOfGas}`,
            intake: `${gasIntakeData?.gasVolume ?? ""}`
        },
        {
            label: `${LABELS?.volumeOfOil}`,
            intake: `${gasIntakeData?.oilVolume ?? ""}`
        },
        {
            label: `${LABELS?.volumeOfWater}`,
            intake: `${gasIntakeData?.waterVolume ?? ""}`
        },
        {
            label: `${LABELS?.totalFluidVolume}`,
            intake: `${gasIntakeData?.tfv ?? ""}`
        },
        {
            label: `${LABELS?.freeGas}`,
            intake: `${gasIntakeData?.freeGas ?? ""}`
        },
        {
            label: `${LABELS?.gor} (${LABELS?.gorGlrUnit})`,
            intake: `${gasIntakeData?.gor ?? ""}`
        },
        {
            label: `${LABELS?.glr} (${LABELS?.gorGlrUnit})`,
            intake: `${gasIntakeData?.glr ?? ""}`
        },
        {
            label: `${LABELS?.liquidPhaseDensity}`,
            intake: `${gasIntakeData?.liquidPhaseDensity ?? ""}`
        },
        {
            label: `${LABELS?.gasCompressibility}`,
            intake: `${gasIntakeData?.gasCompressibility ?? ""}`
        },
        {
            label: `${LABELS?.pressure} (${LABELS?.psi})`,
            intake: `${gasIntakeData?.pip ?? ""}`
        },
        {
            label: `${LABELS?.compositeSpGr}`,
            intake: `${gasIntakeData?.compositeSpGr ?? ""}`
        },
        {
            label: `${LABELS?.liquidPhaseSpGr}`,
            intake: `${gasIntakeData?.liquidPhaseSpGr ?? ""}`
        },
        {
            label: `${LABELS?.finalTemp}`,
            intake: `${gasIntakeData?.temperatureOut ?? ""}`
        },
    ];

    return (
        <div className="">
            {
                loading
                    ? <WidgetLoader isLoading={loading} />
                    : gasIntakeData && Object?.keys(gasIntakeData)?.length > 0 && data?.length > 0 && fluidInput?.gasAvailblty === "1" && <TableComponent
                        columns={columns}
                        data={data}
                        rowsPerPage={1}
                        height={720}
                        overFlowClass="overflow-y-auto"
                    />
            }
        </div>
    );
};

export default GasCalculations;